import cn from 'classnames'
import type {ReactNode, RefObject} from 'react'
import type {BackgroundColors} from 'src/common/types'

interface ContainerProps {
  children: ReactNode
  'data-slice-type'?: string
  'data-slice-variation'?: string
  backgroundColor?: BackgroundColors
  className?: string
  containerRef?: RefObject<HTMLDivElement>
  overflowHidden?: boolean
  style?: Record<string, string | number>
  id?: string
  // Temporal to migrate to new nav
  extraPaddingTop?: boolean
}

export const Container = ({
  backgroundColor = 'Moss White',
  children,
  className,
  containerRef,
  overflowHidden = true,
  style,
  extraPaddingTop,
  id,
  ...dataSliceProps
}: ContainerProps) => {
  const isDataNavDark =
    backgroundColor === 'Green/900' || backgroundColor === 'Moss Black' || backgroundColor === 'Dark Green'

  return (
    <section
      className={cn(`flex scroll-mt-16 justify-center pb-8 md:pb-12 ${className || ''}`, {
        'bg-beige-100': backgroundColor === 'Beige/100',
        'bg-beige-200': backgroundColor === 'Beige/200',
        'bg-beige-300': backgroundColor === 'Beige/300',
        'bg-moss-white': backgroundColor === 'Moss White',
        'bg-moss-black text-moss-white': backgroundColor === 'Moss Black',
        'bg-moss-green-500': backgroundColor === 'Green/500',
        'bg-moss-green-900': backgroundColor === 'Green/900',
        'bg-green-neon': backgroundColor === 'Neon/300',
        'bg-5a7269': backgroundColor === 'Green (legacy)',
        'bg-green-dark': backgroundColor === 'Dark Green',
        'bg-moss-grey-100': backgroundColor === 'Grey/100',
        'bg-transparent': backgroundColor === 'Transparent',
        'bg-ui-green-115': backgroundColor === 'Green/115',
        'overflow-hidden': overflowHidden,
        'pt-24 md:pt-[112px]': extraPaddingTop,
        'pt-8 md:pt-12': !extraPaddingTop,
      })}
      {...dataSliceProps}
      {...(containerRef && {ref: containerRef})}
      data-nav-dark={isDataNavDark}
      style={style}
      {...(id && {id})}
    >
      {children}
    </section>
  )
}
